import {Component, OnInit, ChangeDetectionStrategy, Input} from '@angular/core';

@Component({
  selector: 'leap-review-item',
  templateUrl: './review-item.component.html',
  styleUrls: ['./review-item.component.less', '../../../styles/tab-content.less'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class ReviewItemComponent implements OnInit {

  constructor() { }

  @Input() reviewerName: string;
  @Input() reviewText: string;
  @Input() rating: number;
  @Input() avatar: string;
  @Input() isBuyer: boolean;
  @Input() isSeller: boolean;
  @Input() isInstructor: boolean;
  @Input() visible: boolean;

  ngOnInit() {

  }

  parseTime() {

  }
}
